import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@hub-la/shadcn'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: (event) => void
}

export const ConfirmationModal: React.FC<Props> = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-xl font-bold mb-1">{t('confirmationModal.post.title')}</DialogTitle>

          <p className="text-base">{t('confirmationModal.post.subtitle')}</p>
        </DialogHeader>

        <DialogFooter className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose}>
            {t('confirmationModal.post.cancel')}
          </Button>

          <Button variant="destructive" onClick={onConfirm}>
            {t('confirmationModal.post.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
